import odata from 'odata-client';
import {
    EDIT_ENTRY_REQUEST,
    EDIT_ENTRY_ERROR,
    EDIT_ENTRY_SUCCESS,
    TOKEN_EXPIRED
} from '../types';
import { getServiceUrl, getDefaultHeader } from '../../utils';
import { showNotification } from '../notification';

export const tokenExpired = () => ({
    type: TOKEN_EXPIRED
});

export const editEntryRequest = () => ({
    type: EDIT_ENTRY_REQUEST,
});

export const editEntryError = errorOrResults => ({
    type: EDIT_ENTRY_ERROR,
    error: errorOrResults.message,
});

export const editEntrySuccess = (payload, entryType) => ({
    type: EDIT_ENTRY_SUCCESS,
    entryType,
    payload,
});

export default (entryId, entryType, entry) => async (dispatch, getState) => {
    dispatch(editEntryRequest());
    const query = odata({service: getServiceUrl()}).resource(entryType, entryId);

    const errorOrResult = await query.patch(entry, {
        headers: {
          Authorization: `Bearer ${getState().user.token}`,
          "X-IAS-SessionID": `${getState().user.changeMessageToken}`,
          ...getDefaultHeader()
        }
    })
        .then(resp => resp)
        .then(res => {
            const ok = res.statusCode <= 299 && res.statusCode >= 200;

            if (res.statusCode === 500) {
                const body = JSON.parse(res.body);
                const { Error: { Code, Message } } = body
                let errorKey = "GENERAL_SERVER_ERROR"
                if (Code === "MessageCorrelationFailedTryAgain" || Code === "MessageCorrelationFailed") {
                    errorKey = Message
                }
                return new Error(errorKey);
            } else if (!ok) {
                console.log('edit entry api error', res.toJSON());
                const body = JSON.parse(res.body);
                const { Error: { Message } } = body
                const errorKey = res.statusCode === 401 && Message ? `401: ${Message}` : Message ? `${Message}` : "API_ERROR";
                return new Error(errorKey);
            } else {
                return true;
            }
        })
        .catch((error) => {
            console.error('Error:', error);
            dispatch(showNotification("Request probably timed out.", "error"))
        })

    if (errorOrResult instanceof Error) {
        dispatch(editEntryError(errorOrResult));
        if (errorOrResult.message.split(":")[0] === "401") {
            dispatch(tokenExpired());
            dispatch(showNotification(errorOrResult.message.split(":")[1], "error"))
        }
        console.log("CODE ERROR: ", errorOrResult.message);
        dispatch(showNotification(errorOrResult.message, "error"))
        return errorOrResult;
    } else {
        dispatch(showNotification("SUCCESSFUL_SAVE", "success"))
    }

    dispatch(editEntrySuccess({ ...entry, ID: entryId}, entryType));

    return errorOrResult;
};